// components/Unauthorized.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const Unauthorized = () => {
  return (
    <div className="Profile">
      <FontAwesomeIcon icon={faTriangleExclamation}  />
      <h1 >Access Denied</h1>
      <p >
        You do not have the required permissions to view this page.
      </p>
      <Link
        to="/auth/profile"
        >
        <FontAwesomeIcon icon={faArrowLeft} className="manage-button" />
        Return to Profile
      </Link>
    </div>
  );
};

export default Unauthorized;
